import React, {
  Component,
  Fragment,
  useEffect,
  useMemo,
  useState,
} from "react";

import users from "../../assets/images/icon_home/user.svg";
import * as API from "../../core/service/api.js";
import {} from "../../core/feature/store";
import * as api_info from "../../core/service/api_info";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import Tabs from "../__template/BottomNavComponent";
import "react-lazy-load-image-component/src/effects/blur.css";
import { formatCurrency } from "../../config/global";
import User from "../../core/models/user";
import Config from "../../config/Config";
import { useDispatch } from "react-redux";
import { setToken } from "../../core/feature/token/tokenSlice";
import { removeUser, setUser } from "../../core/feature/user/userSlice";
import { Listbox } from "@headlessui/react";
import TabsMobile from "../__template/TabsMobileComponent";
import { useTranslation } from "react-i18next";
import userIcon from "../../assets/images/icon_profile/user.svg";

const AccountMobile = () => {
  const balance: Number = useAppSelector((state) => state.balance.balance);
  const user: User = useAppSelector((state) => state.user.user);
  const token: String = useAppSelector((state) => state.token.token);
  const [pages, setPage] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const { t } = useTranslation();

  const [data, setData] = useState<any>([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [dataNews, setdataNews] = useState<any>([]);
  let [isOpen, setIsOpen] = useState(true);
  let [loading, setLoading] = useState(false);
  let [noData, setNoData] = useState(false);
  const [tags, setTags] = useState<any>([]);
  const [selectedTags, setSelectedTags] = useState<any>([]);

  const env = Config.BaseUrlDev;

  useEffect(() => {
    if (user == undefined) {
      navigate("/login", { replace: true });
    } else {
      getData();
    }
  }, []);
  useEffect(() => {
    console.log("tes", location.pathname.split("/")[2]);
    if (location.pathname.split("/")[2] != undefined) {
      dispatch(setToken(location.pathname.split("/")[2]));
      API.credentialCheck().then((resCredential) => {
        dispatch(setUser(resCredential.data.user));
        getData();
      });
    }
  }, [location.pathname.split("/")[2]]);

  function getData() {
    let temp = JSON.parse(String(localStorage.getItem("user_redux")));
    temp = temp.accounts[0].callerIdentities;
    console.log(temp);
    setData(temp);
  }

  function getImgContent(url: string) {
    return env + "main_a/image/get/" + url + "/pas";
  }

  return (
    <>
      <div className="relative min-h-screen h-full z-50 bg-psp-primary pb-10">
        <div className="bg-white px-8 pt-8 pb-3  sticky top-0 z-50">
          <TabsMobile
            name={`${t("ACCOUNT.title")}`}
            backUrl={"home"}
          ></TabsMobile>
        </div>
        <div className="min-h-screen h-full mb-6 px-4 py-6 bg-psp-primary top-to-bottom">
          <section className="mt-1 flex flex-col gap-3">
            {data.map((item: any) => {
              return (
                <div className="flex flex-row z-10">
                  <div className="w-24 h-24">
                    {item.photoUrl && (
                      <img
                        src={getImgContent(item.photoUrl)}
                        alt=""
                        className="rounded-l-2xl relative w-24 object-cover h-24"
                      />
                    )}
                    {!item.photoUrl && (
                      <img
                        src={userIcon}
                        alt=""
                        className="rounded-l-2xl relative w-24 object-cover h-24"
                      />
                    )}
                  </div>
                  <div
                    className={`flex flex-col rounded-r-2xl px-3 justify-center ${
                      item.active ? "bg-white" : "bg-gray-300"
                    } w-full`}
                  >
                    <h1
                      className={`font-montserrat m-0 font-medium text-sm ${
                        item.active ? "text-black" : "text-gray-500"
                      }`}
                    >
                      {item.name}
                    </h1>
                    <h1
                      style={{ fontSize: 11 }}
                      className={`font-montserrat m-0 font-normal ${
                        item.active ? "text-black" : "text-gray-500"
                      }`}
                    >
                      {item.title}: {item.callerId}
                    </h1>
                  </div>
                </div>
              );
            })}
          </section>
        </div>
      </div>
    </>
  );
};

export default AccountMobile;
